import React from 'react'
import PanelSearchCnpj from '../search/PanelSearchCnpj'
import TablePlanSearch from './TablePlanSearch'

function PanelPlanSearchCnpj({
  cnpj,
}) {
  return (
    <PanelSearchCnpj
      email={cnpj}
      TableComponent={TablePlanSearch} />
  )
}

export default (PanelPlanSearchCnpj)